<nz-drawer
  [nzClosable]="true"
  [nzMaskStyle]="maskObj"
  [nzWidth]="1200"
  [nzVisible]="showPopup"
  [nzTitle]="resTitle"
  [nzBodyStyle]="styleObj"
  [nzWrapClassName]="'research-popup-drawer'"
  (nzOnClose)="closeModal()"
>
  <ng-template #resTitle>
    <div class="header">
      <span>Research Snippets for : {{ lineItemName }}</span>
    </div>
  </ng-template>
  <ng-container *nzDrawerContent>
    <div class="research-popup">
      <div class="reports-container">
        <div class="documents-container">
          <!-- <div class="result-div">
            <span>Reports Found : {{ totalReports }} </span>
          </div> -->
          <!-- run for loop to make list, and infinite scroll here -->

          <div class="documents-list">
            <ng-container *ngIf="loading">
              <ul>
                <li *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6, 7]">
                  <nz-skeleton
                    [nzTitle]="true"
                    [nzActive]="true"
                    [nzParagraph]="false"
                  ></nz-skeleton>
                </li>
              </ul>
            </ng-container>
            <!-- <ng-container *ngFor="let data of documentsList; index as i">
                <section *ngIf="!loading" (click)="selectDocument(data)">
                  <div
                    class="document-item"
                    [ngClass]="{
                      selected: data.document_id === currentDocument.document_id
                    }"
                  >
                    <div class="title" nz-tooltip [nzTooltipTitle]="data.title">
                      <span class="index">{{ i + 1 }}.</span>
                      <span class="title-text">{{
                        data.title | textEllipsis: 100
                      }}</span>
                    </div>
                    <div class="details">
                      <div class="first-row">
                        <span class="bold">Date published : </span
                        ><span>{{
                          data.publish_date | date: "dd-MMM-yyyy"
                        }}</span>
                        <div class="sentence-instance-count">
                          <span *ngIf="data.sentence_hits != 1"
                            >{{ data.sentence_hits }} SENTENCES</span
                          >
                          <span *ngIf="data.sentence_hits == 1"
                            >{{ data.sentence_hits }} SENTENCE</span
                          >
                        </div>
                      </div>
                      <div class="second-row">
                        <span class="bold">Published by : </span
                        ><span
                          >{{ data.analyst_name }} |
                          {{ data.broker_name }}</span
                        >
                      </div>
                    </div>
                  </div>
                </section>
              </ng-container> -->
            <ng-container *ngIf="!loading">
              <nz-timeline>
                <ng-container *ngFor="let data of allDocumentsList; index as i">
                  <nz-timeline-item
                    [nzLabel]="documentTimeLineItemLabel"
                    [nzDot]="dotTemplate"
                  >
                    <div
                      [ngClass]="{
                        selected:
                          data.document_id == currentDocument.document_id,
                        included: documentsList.includes(data.document_id)
                      }"
                      (click)="selectDocument(data)"
                    >
                      <div class="document-title-name">
                        <span>{{ data.title }}</span>
                        <span class="report-link" *ngIf="data.document_url">
                          <a target="_blank" href="{{ data.document_url }}"
                            ><va-icon
                              class="link-icon"
                              size="small"
                              name="external-link"
                            ></va-icon></a
                        ></span>
                      </div>

                      <div
                        class="sentence-instance-count"
                        *ngIf="documentsList.includes(data.document_id)"
                      >
                        <span *ngIf="data.sentence_hits != 1"
                          >{{ data.sentence_hits }} sentences found</span
                        >
                        <span *ngIf="data.sentence_hits == 1"
                          >{{ data.sentence_hits }} sentence found</span
                        >
                      </div>
                    </div>
                  </nz-timeline-item>
                  <ng-template #documentTimeLineItemLabel>
                    <div
                      class="document-label"
                      [ngClass]="{
                        selected:
                          data.document_id == currentDocument.document_id,
                        included: documentsList.includes(data.document_id)
                      }"
                      (click)="selectDocument(data)"
                    >
                      <div class="first-row">
                        <span class="date">{{
                          data.publish_date | date: "dd-MMM-yyyy hh:mm a"
                        }}</span>
                      </div>
                      <div class="second-row" [title]="data.broker_name">
                        <span> {{ data.broker_name }}</span>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template #dotTemplate>
                    <!-- check if document present in document list show as green, rest as grey and selected as filled-->
                    <span
                      *ngIf="
                        documentsList.includes(data.document_id) &&
                        data.document_id != currentDocument.document_id
                      "
                    >
                      <va-icon
                        class="file-icon doc-included included"
                        size="small"
                        name="file-contract"
                      ></va-icon>
                    </span>
                    <span
                      *ngIf="data.document_id == currentDocument.document_id"
                      class="selected"
                    >
                      <va-icon
                        class="file-icon current-doc"
                        size="small"
                        name="file-contract"
                      ></va-icon
                    ></span>
                    <span *ngIf="!documentsList.includes(data.document_id)">
                      <va-icon
                        class="file-icon doc-disabled"
                        size="small"
                        name="file-contract"
                      ></va-icon>
                    </span>
                  </ng-template>
                </ng-container>
              </nz-timeline>
            </ng-container>
          </div>
        </div>
        <div class="sentences-list">
          <!-- run for loop to make sentence instances -->
          <ng-container *ngIf="loadingSentences">
            <div class="sentence-result">
              <ul>
                <li
                  *ngFor="
                    let dummySection of [
                      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13
                    ]
                  "
                >
                  <nz-skeleton
                    [nzTitle]="true"
                    [nzActive]="true"
                    [nzParagraph]="false"
                  ></nz-skeleton>
                </li>
              </ul>
            </div>
          </ng-container>

          <ng-container *ngIf="!loadingSentences">
            <div class="sentence-result">
              <span class="count" *ngIf="sentencesList.length > 1"
                >{{ sentencesList.length }} Sentences Found</span
              >
              <span class="count" *ngIf="sentencesList.length == 1"
                >{{ sentencesList.length }} Sentence Found</span
              >
            </div>
            <div *ngFor="let sentence of sentencesList; index as i">
              <section class="sentence-item">
                <div class="instance-count">
                  <span>{{ sentence.header_text }}</span>
                </div>
                <div class="instance-text">
                  <p [innerHtml]="sentence.sentence_text"></p>
                </div>

                <div class="footer">
                  <div class="sentence-info">
                    <span class="score"
                      >Score : {{ sentence.snippet_score || "NA" }}</span
                    >
                    <span
                      class="polarity-flag"
                      [title]="'Polarity : ' + sentence.polarity"
                    >
                      <va-icon
                        name="flag"
                        class="polarity-flag"
                        [style.color]="sentence.polarityColor"
                      ></va-icon>
                    </span>
                  </div>
                  <div class="buttons">
                    <button
                      nz-button
                      nzType="default"
                      class="btn yes-btn"
                      [ngClass]="{
                        'va-button--selected': sentence.optionSelected === 'Yes'
                      }"
                      (click)="setYes(sentence.sentence_id)"
                    >
                      <span nz-icon nzType="like" nzTheme="fill"></span>
                    </button>

                    <button
                      nz-button
                      nzType="default"
                      class="btn no-btn"
                      [ngClass]="{
                        'va-button--selected': sentence.optionSelected === 'No'
                      }"
                      (click)="setNo(sentence.sentence_id)"
                    >
                      <span nz-icon nzType="dislike" nzTheme="fill"></span>
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</nz-drawer>
